import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGroupJackpot = (params) => {
    return axios.get(`${backendHost}/api/admin/jackpot/group/list`, {params});
};

export {
    getGroupJackpot
}